<h3>Courses Form</h3>

<div class="source-form-card">
  <p-card [header]="courseId ? 'Edit Course' : 'New Course'">
    <form [formGroup]="courseForm">
      <div style="display: flex; gap: 10px">
        <div class="form-field">
          <label class="block" pTooltip="Image should be handle after upload">Subir imagen</label>
          <img width="218px" src="assets/images/face-3.jpg" />
          <dc-cropper-modal [imgStorageSettings]="storageImgSettings" (imageUploaded)="handleImageUpload($event)"></dc-cropper-modal>
        </div>

        <div style="width: 100%">
          <div class="form-field">
            <label for="name" class="block">Name</label>
            <input pInputText id="name" type="text" formControlName="name" placeholder="Enter source name" />
          </div>

          <div class="form-field">
            <label for="description" class="block">Description</label>
            <textarea id="description" pTextarea formControlName="description" rows="5" class="w-full" placeholder="Enter source content"> </textarea>
          </div>
        </div>
      </div>
    </form>

    <div style="display: flex; justify-content: flex-end">
      <p-button (click)="save()" label="Save Course" [disabled]="!courseForm.valid" icon="pi pi-check" iconPos="right"> </p-button>
    </div>
  </p-card>
</div>
